import { useResizeObserver } from '@vueuse/core'
import { ref, useTemplateRef } from 'vue'

export const useFieldsActualWidth = () => {
  const FIELDS_GROUP_REFERENCE_TOKEN = 'fields-group'

  const fieldsGroupReference = useTemplateRef(FIELDS_GROUP_REFERENCE_TOKEN)
  const fieldsGroupActualWidth = ref('100%')

  useResizeObserver(fieldsGroupReference, entries => {
    const entry = entries[0]
    const { width } = entry.contentRect
    if (width) {
      fieldsGroupActualWidth.value = `${width}px`
    }
  })

  return {
    fieldsGroupActualWidth,
    FIELDS_GROUP_REFERENCE_TOKEN
  }
}
